"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppConfig = void 0;
var AppConfig = exports.AppConfig = (function () {
    function AppConfig() {
    }
    AppConfig.confForLoacal = {
        confAPI: 'MIERUKAWEBID',
        APIKey: 'PL32REJRJ92qAG8XWNrpC3w2tVjkIDFn8vpyCk4c',
        getDataInterval: 10 * 1000,
        debugMode: true,
        currrentFrame: {},
        mierukaWebId: '',
    };
    AppConfig.confForDev = {
        confAPI: 'https://6vbfyjfc9a.execute-api.ap-northeast-1.amazonaws.com/techmock/config',
        APIKey: 'PL32REJRJ92qAG8XWNrpC3w2tVjkIDFn8vpyCk4c',
        getDataInterval: 10 * 60 * 1000,
        debugMode: false,
        currrentFrame: {},
        mierukaWebId: '',
    };
    AppConfig.confForProd = {
        confAPI: 'https://4zuny84hkd.execute-api.ap-northeast-1.amazonaws.com/service/config',
        APIKey: 'bN3AMBUtoZ4jhiCpok6xD7lWgB94mZuY1Cqao0rT',
        getDataInterval: 10 * 60 * 1000,
        debugMode: false,
        currrentFrame: {},
        mierukaWebId: '',
    };
    AppConfig.cruiseKey = '';
    AppConfig.APP_CONFIG = AppConfig.confForLoacal;
    return AppConfig;
}());
